import { render, staticRenderFns } from "./ProviderCard.vue?vue&type=template&id=24a465be"
import script from "./ProviderCard.vue?vue&type=script&lang=ts"
export * from "./ProviderCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports